/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExternalEhrType } from './ExternalEhrType';
import {
    ExternalEhrTypeFromJSON,
    ExternalEhrTypeFromJSONTyped,
    ExternalEhrTypeToJSON,
    ExternalEhrTypeToJSONTyped,
} from './ExternalEhrType';
import type { Lead } from './Lead';
import {
    LeadFromJSON,
    LeadFromJSONTyped,
    LeadToJSON,
    LeadToJSONTyped,
} from './Lead';

/**
 * 
 * @export
 * @interface ExternalEhrPatient
 */
export interface ExternalEhrPatient {
    /**
     * 
     */
    patient_id?: string;
    /**
     * 
     */
    type?: ExternalEhrType;
    /**
     * 
     */
    details_push_date?: string;
    /**
     * 
     */
    details_extraction_date?: string;
    /**
     * 
     */
    is_extracting_details?: boolean;
    /**
     * 
     */
    is_screener_document_upload_in_progress?: boolean;
    /**
     * 
     */
    is_additional_document_upload_in_progress?: boolean;
    /**
     * 
     */
    is_generated_document_upload_in_progress?: boolean;
    /**
     * Set once PointClickCare permanently refused a demographics write for this chart. When present, exacare ai no longer sends PATCH /patients/{patientId} and the Additional Referral Information section is read-only.
     */
    demographics_locked_at?: string;
    /**
     * 
     */
    leads?: Array<Lead>;
}



/**
 * Check if a given object implements the ExternalEhrPatient interface.
 */
export function instanceOfExternalEhrPatient(value: object): value is ExternalEhrPatient {
    return true;
}

export function ExternalEhrPatientFromJSON(json: any): ExternalEhrPatient {
    return ExternalEhrPatientFromJSONTyped(json, false);
}

export function ExternalEhrPatientFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalEhrPatient {
    if (json == null) {
        return json;
    }
    return {
        
        'patient_id': json['patient_id'] == null ? undefined : json['patient_id'],
        'type': json['type'] == null ? undefined : ExternalEhrTypeFromJSON(json['type']),
        'details_push_date': json['details_push_date'] == null ? undefined : json['details_push_date'],
        'details_extraction_date': json['details_extraction_date'] == null ? undefined : json['details_extraction_date'],
        'is_extracting_details': json['is_extracting_details'] == null ? undefined : json['is_extracting_details'],
        'is_screener_document_upload_in_progress': json['is_screener_document_upload_in_progress'] == null ? undefined : json['is_screener_document_upload_in_progress'],
        'is_additional_document_upload_in_progress': json['is_additional_document_upload_in_progress'] == null ? undefined : json['is_additional_document_upload_in_progress'],
        'is_generated_document_upload_in_progress': json['is_generated_document_upload_in_progress'] == null ? undefined : json['is_generated_document_upload_in_progress'],
        'demographics_locked_at': json['demographics_locked_at'] == null ? undefined : json['demographics_locked_at'],
        'leads': json['leads'] == null ? undefined : ((json['leads'] as Array<any>).map(LeadFromJSON)),
    };
}

export function ExternalEhrPatientToJSON(json: any): ExternalEhrPatient {
    return ExternalEhrPatientToJSONTyped(json, false);
}

export function ExternalEhrPatientToJSONTyped(value?: ExternalEhrPatient | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patient_id': value['patient_id'],
        'type': ExternalEhrTypeToJSON(value['type']),
        'details_push_date': value['details_push_date'],
        'details_extraction_date': value['details_extraction_date'],
        'is_extracting_details': value['is_extracting_details'],
        'is_screener_document_upload_in_progress': value['is_screener_document_upload_in_progress'],
        'is_additional_document_upload_in_progress': value['is_additional_document_upload_in_progress'],
        'is_generated_document_upload_in_progress': value['is_generated_document_upload_in_progress'],
        'demographics_locked_at': value['demographics_locked_at'],
        'leads': value['leads'] == null ? undefined : ((value['leads'] as Array<any>).map(LeadToJSON)),
    };
}

